"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var theme = require("./theme.scss");
var QuickReportAction = /** @class */ (function (_super) {
    tslib_1.__extends(QuickReportAction, _super);
    function QuickReportAction(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onIconClick = function () {
            var _a = _this.props, item = _a.item, onClick = _a.onClick;
            onClick(item);
        };
        return _this;
    }
    QuickReportAction.prototype.render = function () {
        return (React.createElement("div", { className: theme.quickFilter },
            React.createElement(ui_1.Tooltip, { position: "top", title: this.props.tooltipTitle },
                React.createElement("span", { onClick: this.onIconClick, className: theme.icon },
                    React.createElement(ui_1.Icon, { iconName: this.props.iconName, size: 1.5 }))),
            this.props.children));
    };
    return QuickReportAction;
}(React.Component));
exports.default = QuickReportAction;
